import { combineReducers } from 'redux';

import actions from './actions-reducer';
import aggDomains from './aggregate-domains-reducer';
import aggResults from './aggregate-results-reducer';
import apps from './apps-reducer';
import auth from './auth-reducer';
import canvases from '../../dashboard/reducers/canvas-reducer';
import claimedDomainsWithCounts from './claimed-domains-with-counts-reducer';
import collections from '../../dashboard/reducers/collection-reducer';
import dmarc from '../../reports/reducers/dmarc-reducer';
import domainGroups from './domain-groups-reducer';
import domainManagement from './domain-management-reducer';
import domainNotes from './domain-notes-reducer';
import domains from './domains-reducer';
import domainsOverview from './domains-overview-reducer';
import exportReport from '../../reports/reducers/export-report-reducer';
import modal from './modal-reducer';
import recognizedSenders from './recognized-senders-reducer';
import reportsConfig from '../../reports/reducers/reports-config-reducer';
import rightPane from './right-pane-reducer';
import senders from '../../common/reducers/senders-reducer';
import snackbar from './snackbar-reducer';
import suggestedDomains from './suggested-domains-reducer';
import uiState from './ui-state-reducer';
import unclaimedDomainsWithCounts from './unclaimed-domains-with-counts-reducer';
import whois from './whois-reducer';
import widgets from '../../dashboard/reducers/widget-reducer';

const appReducer = combineReducers( {
    actions,
    aggDomains,
    aggResults,
    appConfig: ( state = {}, action ) => state,
    apps,
    auth,
    canvases,
    claimedDomainsWithCounts,
    collections,
    dmarc,
    domainGroups,
    domainManagement,
    domainNotes,
    domains,
    domainsOverview,
    exportReport,
    modal,
    recognizedSenders,
    reportsConfig,
    rightPane,
    senders,
    snackbar,
    suggestedDomains,
    uiState,
    unclaimedDomainsWithCounts,
    whois,
    widgets,
} );

export default appReducer;
